import { apiRoutes } from "../types/api-routes";
import { baseUrl } from "../types/config";
import service from "./service";

/**
 * Vendor profile payload from `GET api/v1/Vendors/profile` (nested under `data` on the HTTP body).
 *
 * @typedef {Object} VendorProfile
 * @property {boolean} [isFitEnabled] When omitted, UI should treat fit recommendations as disabled until loaded.
 * Additional vendor fields are returned at runtime.
 */

/**
 * @returns {Promise<{ data: VendorProfile }>}
 */
export const getProfile = () => {
  return service({
    url: `${baseUrl}/${apiRoutes.PROFILE}`,
    method: "get",
  });
};

export const sendUpdateProfileRequest = (data, signal) => {
  return service({
    url: `${baseUrl}/${apiRoutes.PROFILE}`,
    data,
    method: "patch",
    signal,
  });
};

export const updateProfileInfo = (data) => {
  return service({
    url: `${baseUrl}/${apiRoutes.CONTACT}`,
    data,
    method: "put",
  });
};

export const markTutorialAsRead = (signal) => {
  return service({
    url: `${baseUrl}/${apiRoutes.TUTORIAL}`,
    method: "put",
    signal,
  });
};
